import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { ROUTES } from "../../data/content";
import Footer from "../layout/Footer";

const NotFound = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Page not found | Artdacity</title>
        <meta
          name={"robots"}
          content={"noindex"}
        />
      </Helmet>
      <main className={"not-found"}>
        <p className={"not-found-logo"}>
          <span className={"hero-title-art"}>ART</span>
          <span className={"hero-title-dacity"}>dacity</span>
        </p>
        <h1 className={"not-found-heading"}>Page not found</h1>
        <p>The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
        <Link
          to={ROUTES.HOME}
          className={"btn"}
        >
          Back to home
        </Link>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default NotFound;
